import { useLocation, useNavigate } from "react-router-dom";
import { UnitCardProps } from "./UnitCard.interface";
import { routes } from "../../shared/router/routes";
import { getFormattedPath } from "../../shared/helpers/utils";
import { useCallback, useContext, useEffect, useState } from "react";
import { ModuleContext } from "../../shared/providers/module/module.provider";
import { AnalyticsContext } from "../../shared/providers/analytics/analytics.provider";
import { AuthenticationContext } from "../../shared/providers/authentication/authentication.provider";

function UnitCard({ unit, index, moduleId, moduleImage, fromUnit }: UnitCardProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const { module } = useContext(ModuleContext);
    const { setEvent } = useContext(AnalyticsContext);
    const { user } = useContext(AuthenticationContext);
    const [progress, setProgress] = useState(0);
    const fromExplore = !!(location.state as { fromExplore?: boolean })?.fromExplore;

    useEffect(() => {
        if (!module) return;
        const unitProgress = module.unitsProgress?.find((u) => u.id === unit.id);

        if (!unitProgress) return;

        const numberItems = module.units?.find((u) => u.id === unit.id)?.items.length ?? 1;
        const progress = ((unitProgress?.completedItems ?? 0) / numberItems) * 100;

        setProgress(progress >= 100 ? 100 : progress);
    }, [module, unit]);

    const navigateUnit = useCallback(() => {
        if (fromUnit)
            setEvent({
                event_name: "app_unit_unit",
                event_category: "content_navigation",
                event_action: "app_unit_unit",
                user_token: user?.id,
                company_id: user?.company.id,
                unit_id: unit.id
            });

        const path = getFormattedPath(routes.UNIT.path, { moduleId, unitId: unit.id });
        navigate(path, {
            state: fromExplore ? { fromExplore: true } : undefined
        });
    }, [moduleId, unit, fromUnit, fromExplore, user]);

    return (
        <button
            type="button"
            className="card card_unit d-flex gap-1 p-02 pe-1 w-100"
            onClick={navigateUnit}>
            <figure className="unit_thumbnail" data-index={index}>
                <img src={moduleImage} alt={unit.title} />
            </figure>
            <div className="w-100 d-flex flex-column gap-02">
                <div className="d-flex justify-content-between gap-2">
                    {!!unit.tag && (
                        <span
                            className={`color-${unit?.tag_color ?? "yellow"}-500 text-bd4-bd text-uppercase`}>
                            {unit.tag}
                        </span>
                    )}

                    {!unit.tag && (
                        <h2 className="lineclamp-2 text-bd2-bd color-neutrals-black card_title mt-02 text-start">
                            {unit.title}
                        </h2>
                    )}
                    {progress === 100 && (
                        <i className="icon icon-24 icon-Checkmark--filled color-green-500 ms-auto" />
                    )}
                </div>
                {!!unit.tag && (
                    <h2 className="lineclamp-1 text-bd2-bd color-neutrals-black card_title text-start">
                        {unit.title}
                    </h2>
                )}
            </div>
        </button>
    );
}

export default UnitCard;
